var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"viewBox":"0 0 64 64"}},[_c('path',{staticClass:"st0",attrs:{"d":"M2,32 a10,10 0 0 1 20,0 a10,10 0 0 0 20,0 a10,10 0 0 1 20,0"}}),_c('line',{staticClass:"st1",attrs:{"x1":"0","x2":"64","y1":"32","y2":"32"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }